import { axiosICPLBEInstance } from "../../../utils/axios_config";

export default function CustomerService() {
    this.getCustomers = (payload) => {
        return axiosICPLBEInstance.get(`customer?page=${payload.page}&page_length=${payload.page_length}`);
    }
}